import { doc, getDoc } from "@firebase/firestore";
import { showWarningSnackbar } from "../../../../../shared/snackbar/snackbar-slice";
import { showItemInformationDialog } from "./item-information/item-information-list/item-information-list-slice";
import { setItemPhotosList } from "./item-photos/item-photos-list/item-photos-list-slice";
import { hideLoading, showLoading } from "./item-tabs-slice";

export const getItemDetailsDataService = async (dispatch, db, coll, id) => {
    dispatch(showLoading());
    try {
        const docRef = doc(db, coll, id);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            dispatch(showItemInformationDialog(docSnap.data()));
            const item_data = docSnap.data();
            if(Boolean(item_data?.image_url) === true) {
                dispatch(setItemPhotosList(item_data.image_url));
            }
            return docSnap.data();
        } else {
            dispatch(showWarningSnackbar("This document no longer exists."));
        }
    } catch(e) {
        console.error("ItemTabs getItemDetailsDataService error: ", e);
    }
    finally {
        dispatch(hideLoading());
    }
};